import React, { ReactNode } from 'react';
import styles from './modalfooter.module.scss';

interface Props {
  children: ReactNode;
  className?: string;
}

const ModalFooter = ({ children, className }: Props) => {
  return (
    <div className={`modal-footer ${styles.footer}${className ? ` ${className}` : ""}`}>
      {children}
    </div>
  )
}

export default ModalFooter;
